@if (dropdownInput) {
  <div
    class="chart-dropdown"
    >
    <div class="row" [ngStyle]="{ color: rowColor }">
      <div class="col-8 instrument">
        @if (isCash) {
          {{ 'investmentChartCategories.CASH' | translate }}
        } @else if (translateNames) {
          {{ 'investmentChartCategories.' + dropdownInput.categoryName | translate }}
        } @else {
          {{ dropdownInput.categoryName }}
        }
      </div>
      <div class="col-4 instrument instrument--sum">
        {{ instrumentSum() | number:'1.0-2' }} %
      </div>
    </div>
  </div>
}